import { Typography } from "@mui/joy";
import { COLOR_GREEN, COLOR_RED } from "../../utils/styles";

function OpenNow(props) {
  return (
    <>
      {props.isOpen
        ? <Typography level="body-sm" fontWeight={700} sx={{ color: COLOR_GREEN }}>
          {"Open"}
        </Typography>
        : <Typography level="body-sm" fontWeight={700} sx={{ color: COLOR_RED }}>
          {"Closed"}
        </Typography>
      }
    </>
  )
}

export default OpenNow;
